import React, { useState, useContext, useEffect } from 'react'
import { Button } from '@material-ui/core'
import './Footer.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils'
import { mapData } from '@/product/common/components'
import { Link } from 'react-router-dom'

const Footer = () => {
    const autopltContext = useContext(AutopltContext)

    const { addCustomer, responseStatus: responseStatusAutoPlt } = autopltContext

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addCustomer(values)
        },
    })

    const subscribe = [
        {
            label: 'Subscribe to our mailing list',
            placeholder: 'Enter your email address',
            class: 'subsInp',
            type: 'text',
            variant: 'filled',
            name: 'email',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusAutoPlt) {
            if (responseStatusAutoPlt.from === 'addCustomer') {
                if (responseStatusAutoPlt.status === 'success') {
                    formik.values.email = ''
                }
            }
        }
    }, [responseStatusAutoPlt])

    return (
        <footer className="noPrint">
            <div className="footCnt customContainer">
                <div className="footTop">
                    <img className="footerLogo" src={LOGO} alt={SITE_NAME} />
                    <div className="footLinks">
                        <ul>
                            <li>
                                <Link id="footer_tg" to="/timeGivers">
                                    TimeGivers
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_tb" to="/timeBidders">
                                    TimeBidders
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_charities" to="/charities">
                                    Charities
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_sponsors" to="/sponsors">
                                    Sponsors
                                </Link>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <Link id="footer_about" to="/about">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_faqs" to="/faqs">
                                    FAQs
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_get_involved" to="/getInvolved">
                                    Get Involved
                                </Link>
                            </li>
                            <li>
                                {/* <Link id="footer_linkedin" to="/">
                                    Linkedin
                                </Link> */}
                                <a href="https://www.linkedin.com/">Linkedin</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footCopyright text-center" dir="ltr">
                    <p>
                        {' '}
                        © {SITE_NAME} {new Date().getFullYear()}. All rights reserved |{' '}
                        <Link to="/privacy">Privacy</Link> and{' '}
                        <Link to="/cookie_policy">cookie policy</Link>
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
